module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "offset-md2": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-list-item-title', {
    staticClass: "headline mb-1"
  }, [_vm._v(" Extracción de Dinero")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text text--darken-2 accent",
    attrs: {
      "icon": "",
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "center": "",
      "right": ""
    },
    on: {
      "click": _vm.redireccion
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Cantidad")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.extracciones), function(extraccion) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "red--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminarextraccion(extraccion)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "blue--text text--darken-2",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editarfactura(extraccion)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(extraccion.tipo_nombre))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_vm._v(_vm._s(extraccion.cantidad))])])
  }), 0)])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58e759cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Extraccion.vue
// module id = 438
// module chunks = 1